import axios from "axios";
import { allApplicationList, applicationsCategory, saveEnvironmentTypes, saveSkillStreamCategory } from "../store/slice/applicationSlice";
import {
  ALLOCATED_APPLICATION_LIST,
  ALLOCATED_MODULE_LIST,
  APPLICATION_LIST,
  ASSIGN_APPLICATION_LIST,
  GROUP_CHILDREN_HIERARCHY,
  GROUP_CHILDREN_LIST,
  TAG_CATEGORY_DETAILS,
  TAG_LIST,
} from "./apiEndpoints";
import { saveRoles, saveGroupTypes } from "../store/slice/configSlice";
import apiClient from ".";
import { saveGroupHierarchy, saveGroupList } from "../store/slice/groupSlice";
import { saveAllModuleCategory, saveTagCategoryList } from "../store/slice/moduleFilter";
import { APPLICATION_LIMIT, MODULE_LIMIT, RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB, RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB, TABS_TYPE_KEY } from "../constant/constants";
import { saveFilter } from "../store/slice/filterOptions";

export const getAllApplication = async (dispatch, UNO_URL, token) => {
  try {
    // const { data } = await axios.get(`${UNO_URL}${APPLICATION_LIST}/all`, {
    //   headers: { Authorization: `Bearer ${token}` },
    // });
    // const allAppList = data.data || [];
    // dispatch(allApplicationList(allAppList));

    let data = await apiClient.get(`${UNO_URL}${APPLICATION_LIST}/all`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    const allAppList = data;
    dispatch(allApplicationList(allAppList));

  } catch (error) {
    console.error(error);
  }
};

export const tagCategoryApplication = async (UNO_URL, token, id) => {
  try {
    // const { data } = await axios.get(`${UNO_URL}${APPLICATION_LIST}/${id}`, {
    //   headers: { Authorization: `Bearer ${token}` },
    // });
    // const list = data.data || [];
    // return list;

    let data = await apiClient.get(`${UNO_URL}${APPLICATION_LIST}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    const list = data;
    return list;

  } catch (error) {
    console.error(error);
    return [];
  }
};
export const getApplicationUsingTagCategory = async (UNO_URL, token, categoryId, shouldReturn = false, dispatch) => {
  try {
    // const { data } = await axios.get(`${UNO_URL}${TAG_LIST}/${categoryId}`, {
    //   headers: { Authorization: `Bearer ${token}` },
    // });

    let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${categoryId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    if (shouldReturn) {
      return data;
    } else {
      dispatch(applicationsCategory({ data: data }));
    }
  } catch (error) {
    console.error(error);
  }
};

export const getGroupTypes = async (dispatch, UNO_URL, token) => {
  try {
    // const { data } = await axios.get(`${UNO_URL}/api/group/roles/list`, {
    //   headers: {
    //     Authorization: `Bearer ${token}`,
    //   },
    // });

    let data = await apiClient.get(`${UNO_URL}/api/group/roles/list`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    dispatch(saveGroupTypes(data.groupTypes));
    dispatch(saveRoles(data.roles));
  } catch (error) {
    console.log(error);
  }
};

export const getGroupHierarchy = async (dispatch, UNO_URL, groupId, token) => {
  try {
    let data = await apiClient.get(`${UNO_URL}${GROUP_CHILDREN_HIERARCHY}/${groupId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    dispatch(saveGroupHierarchy({ hierarchy: data }));
  } catch (error) {
    console.log(error);
  }
};
export const getGroupChildrenList = async (dispatch, UNO_URL, groupId) => {
  try {
    let data = await apiClient.get(`${UNO_URL}${GROUP_CHILDREN_LIST}/${groupId}`);
    dispatch(saveGroupList({ list: data }));
  } catch (error) {
    console.log(error);
  }
};

export const getAllocatedModuleList = async ({ UNO_URL, UUID, queryParams, resourceType }) => {
  let page = queryParams?.page || 1;
  let data = await apiClient.get(`${UNO_URL}${ALLOCATED_MODULE_LIST}/${TABS_TYPE_KEY[resourceType]}/${UUID}`, {
    params: {
      limit: MODULE_LIMIT,
      page: page || 1,
      search: queryParams?.search || null,
      tagIds: queryParams?.tagIds || null,
      categoryIds: queryParams?.categoryIds || null,
      platforms: queryParams?.platforms || null,
      inherit: queryParams?.inherit ?? false
    },
  });
  return data;
};

export const getAssignedApplication = async ({ UNO_URL, UUID, queryParams }) => {
  let page = queryParams?.page || 1;
  let data = await apiClient.get(`${UNO_URL}${ASSIGN_APPLICATION_LIST}/${UUID}`, {
    params: {
      limit: MODULE_LIMIT,
      page: page || 1,
      search: queryParams?.search || null,
      tagIds: queryParams?.tagIds || null,
      platforms: queryParams?.platforms || null,
    },
  });
  return data;
};

export const getAllocatedApplication = async ({ UNO_URL, UUID, queryParams }) => {
  let page = queryParams?.page || 1;
  let data = await apiClient.get(`${UNO_URL}${ALLOCATED_APPLICATION_LIST}/${UUID}`, {
    params: {
      limit: APPLICATION_LIMIT,
      page: page || 1,
      search: queryParams?.search || null,
      tagIds: queryParams?.tagIds || null,
      platforms: queryParams?.platforms || null,
    },
  });
  return data;
};

export const getTagCategory = async (dispatch, UNO_URL, id) => {
  try {
    let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${id}`);
    dispatch(saveTagCategoryList({ data: data }));
  } catch (error) { }
};
export const getModuleTagCategories = async (dispatch, UNO_URL, id) => {
  try {
    let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${id}`);
    let filterChildren = data.children.filter((e) => (e.id != 2 && e.name !== "Sectors"));
    dispatch(saveAllModuleCategory({ data: { ...data, children: filterChildren } }));
  } catch (error) { }
};
export const getEnvironmentTagCategories = async (dispatch, UNO_URL, id) => {
  try {
    let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${id}`);
    dispatch(saveEnvironmentTypes({ data: { ...data } }));
  } catch (error) { }
};
export const getSkillStreamTagCategories = async (dispatch, UNO_URL, id) => {
  try {
    let data = await apiClient.get(`${UNO_URL}${TAG_LIST}/${id}`);
    dispatch(saveSkillStreamCategory({ data: { ...data } }));
  } catch (error) { }
};

export const getFilterCategoryOption = async (dispatch, config) => {
  try {
    const bodyData = {
      ids: [
        config.applicationCategoryId,
        config.categoryFilterId,
        config.environmentFilterId,
        config.skillStream2DFilterId,
        config.moduleFilterId,
      ]
    }

    let data = await apiClient.post(`${config.UNO_URL}${TAG_CATEGORY_DETAILS}`, bodyData);

    let applicationFilter = data.find(e => e.id === config.applicationCategoryId);
    let categoryFilter = data.find(e => e.id === config.categoryFilterId);
    let environmentFilter = data.find(e => e.id === config.environmentFilterId);
    let skillStream2DFilter = data.find(e => e.id === config.skillStream2DFilterId);
    let moduleFilterFilter = data.find(e => e.id === config.moduleFilterId);

    dispatch(saveFilter({ data: { [RESOURCE_APPLICATION_TAB]: applicationFilter } }));
    dispatch(saveFilter({ data: { [RESOURCE_MODULE_TAB]: moduleFilterFilter } }));
    dispatch(saveFilter({ data: { [RESOURCE_ENVIRONMENT_TAB]: environmentFilter } }));
    dispatch(saveFilter({ data: { [RESOURCE_SKILL_STREAM_TAB]: skillStream2DFilter } }));
    dispatch(saveFilter({ data: { [RESOURCE_SKILL_SCHOOL_TAB]: moduleFilterFilter } }));
    dispatch(saveFilter({ data: { "CATEGORY_TAB_FILTER": categoryFilter } }));

  } catch (error) {
    console.log(error);
  }
};